import React, {Suspense} from "react";
import { Route, Redirect } from "react-router-dom";
import ErrorBoundary from "../ErrorBoundary";

const authSplit = ({ component: C, props: cProps, ...rest }) =>
<Suspense fallback={<div>Loading...</div>}>
  <Route {...rest}
    render={props =>
      cProps.isAuthenticated ? <ErrorBoundary><C {...props} {...cProps} /></ErrorBoundary>
      : <Redirect to={`/login?redirect=${props.location.pathname}${props.location?.search}`}
    />}
  />
</Suspense>
export default authSplit;
